import traub from "../machine/traub-machine (1).jpeg";
import cnc from "../machine/cnc.jpg";
import griding from "../machine/griding.jpg";
import rolling from "../machine/Thread-rolling.jpg";
import img2 from "../machineData/img2.png";
import im3 from "../machine/MIll Lathe.jpg";
import im4 from "../machine/surface-grinding.jpg";
import im5 from "../machine/capstan.webp";
import brill from "../machine/brilll.png";
import nm from "../machine/nm.png";
import vmc from "../machine/vmc.png";
import slot from "../machine/slot.png";

const machineData = [
  {
    title: "Traub Machine",
    subtitle:
      "Traub machine is a type of cam-based automatic lathe known for its precision and versatility in high-speed machining.",
    image: traub,
    tags: [],
  },
  {
    title: "CNC Machine",
    subtitle:
      "Computer Numerical Control (CNC) is an automated manufacturing process that controls and operates machinery such as lathes, mills, drills, and more—by way of a computer.",
    image: cnc,
    tags: [], // ✅ added
  },
  {
    title: "VMC - Vertical Milling Machine",
    subtitle:
      "A Vertical Machining Center (VMC) is a  machine where the cutting spindle is vertically oriented. VMCs use computer-programmed commands to automatically perform precise milling, drilling, and tapping operations.",
    image: vmc,
    tags: [], // ✅ added
  },
  {
    title: "Centerless Grinding Machine",
    subtitle:
      "This is a precision centerless grinding machine used for shaping and finishing metal components to exact dimensions and surface quality.",
    image: griding,
    tags: [],
  },
  {
    title: "Thread Rolling Machine",
    subtitle:
      "This is a thread rolling machine, used for forming threads on cylindrical workpieces by cold rolling without material removal.",
    image: rolling,
    tags: [],
  },
  {
    title: "Drilling Machine",
    subtitle:
      "This is a drilling machine, used to precisely drill holes into various materials like metals by rotating a drill bit at high speeds and feeding it into the workpiece",
    image: img2,
   tags: [],
  },
  {
    title: "Mill Lathe",
    subtitle:
      "A mill lathe is a combination machine that integrates both a milling machine and a lathe into a single unit.",
    image: im3,
    tags: [],
  },
  {
    title: "Surface Grinding",
    subtitle:
      "Surface grinding is a machining process that uses a rotating abrasive wheel to remove material from the surface of a workpiece, resulting in a flat, smooth finish.",
    image: im4,
    tags: [],
  },
  {
    title: "Capstan lathe",
    subtitle:
      "A capstan lathe is a specialized semi-automatic machine tool used for high-volume, repetitive production of identical parts",
    image: im5,
    tags: [],
  },
  {
    title: "Barrelling Machine",
    subtitle:
      "The machine operates by rotating a barrel filled with parts, media (such as steel shot or ceramic), and a compound (like soap or liquid), which tumbles the contents against each other to achieve a desired finish.",
    image: brill,
 tags: [],
  },
  {
    title: "Bench Grinding",
    subtitle:
      "Bench grinding uses a bench grinder—a stationary power tool with a motor-driven abrasive wheel—for sharpening tools, deburring metal, and polishing.",
    image: nm,
    tags: [],
  },
  {
    title: "Slotting machine",
    subtitle:
      "A slotting machine, or slotter, is a reciprocating machine tool that uses a vertically moving ram to cut slots, keyways, grooves, and other forms into a workpiece.",
    image: slot,
    tags: [],
  },
];

export default machineData;
